import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceBookingEditor.html?raw'; // (mds) pristine pointed at nonexistent sibling — orphan never bundled by webpack
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/_StatefulBase/_StatefulBase";
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ToasterHelpers } from "../../more/Helpers";

enum EvServiceTypxxxxe {
    "default" = 0,
    "text" = 4
}
class EvServiceBookingEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    //private entity: VAM2types.EvServiceBooking = null;

    private headingNode: HTMLElement;
    private sectionTextEditor: HTMLElement;
    private sectionPriceEditor: HTMLElement;
    private inputInternalNote: HTMLElement;

    private cbOverridePrice: MdsLax<InstanceType<typeof CheckBox>>;
    private cbFreePrice: MdsLax<InstanceType<typeof CheckBox>>;
    private cbTotalPricelist: MdsLax<InstanceType<typeof CheckBox>>;

    private inputPriceUnitChange: MdsLax<InstanceType<typeof NumberInput>>;
    private inputPriceUnitPriceList: MdsLax<InstanceType<typeof NumberInput>>;
    private inputPriceTotalPriceList: MdsLax<InstanceType<typeof NumberInput>>;
    private inputAgioDisagioUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private inputAgioDisagioTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private inputDiscount: MdsLax<InstanceType<typeof NumberInput>>;
    private inputDiscountUnit: MdsLax<InstanceType<typeof NumberInput>>;
    private inputDiscountTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceUnitAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalAfterDisc: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_VatValue: MdsLax<InstanceType<typeof NumberInput>>;
    private numberInput_PriceTotalInclVat: MdsLax<InstanceType<typeof NumberInput>>;

    private edit_evServiceTxt: MdsLax<InstanceType<typeof Edit>>;
    private edit_evServiceNoteInternalTxt: MdsLax<InstanceType<typeof Edit>>;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    setup(entity: VAM2types.EvServiceBooking): void {

        if (!entity) {
            alert(this.id + " setEditedEntity: " + "NO ENTITY");
            return;
        }

        this.setData(entity, entity.service_type == VAM2types.EvServiceType.text ? "service_original_description" : "description");

        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.show(this,
            entity.service_type == 4 ? entity.service_original_description : entity.description,
            null,
            null,
            "saveclose",
            lang.hitch(this, this._onDlgResult));

        dlg.disableButton("save");

        this.dlg = dlg;
    }

    onDirtyChange() {
        this.dlg.enableButton("save", this.isDirty());
    }

    afterSetData(): void {

        let entity = this.sourceData as VAM2types.EvServiceBooking;

        this.headingNode.innerHTML = this.getDisplayname();// entity.description

        switch (entity.service_type) {
            case VAM2types.EvServiceType.default: //standard
                this.hideNode(this.sectionPriceEditor, false);
                if (/*this.hasModule("EvBooking/ServiceEditWithInternalNote")*/ 1) {

                    this.hideNode(this.inputInternalNote, false);
                    this.edit_evServiceNoteInternalTxt.setValue(entity.ev_service_text_internal, true);
                    this.edit_evServiceNoteInternalTxt.isMandatory = false;
                }
                this.hideNode(this.sectionTextEditor, true);

                this.cbOverridePrice.setValue(entity.is_oversteered_price, true);
                this.cbFreePrice.setValue(!entity["ref_pricelist"], true);
                this.cbTotalPricelist.setValue(entity["is_price_total_pricelist"], true);
                this._onPriceCheckboxInputs();

                this.inputPriceUnitChange.setValue(entity.price_unit_change, true);
                this.inputPriceUnitPriceList.setValue(entity.price_unit_pricelist, true);
                this.inputPriceTotalPriceList.setValue(entity.price_total_pricelist, true);
                this.inputAgioDisagioUnit.setValue(entity.value_agiodisagio_unit, true);
                this.inputAgioDisagioTotal.setValue(entity.value_agiodisagio_total, true);
                this.inputDiscount.setValue(entity.discount, true);
                this.inputDiscountUnit.setValue(entity.value_discount_unit), true;
                this.inputDiscountTotal.setValue(entity.value_discount_total, true);
                this.numberInput_PriceUnitAfterDisc.setValue(entity.price_unit_after_disc, true);
                this.numberInput_PriceTotalAfterDisc.setValue(entity.price_total_after_disc, true);
                this.numberInput_VatValue.setValue(entity.VAT_value, true);
                this.numberInput_PriceTotalInclVat.setValue(entity.price_total_incl_VAT, true);
                break;
            case VAM2types.EvServiceType.text: //text

                this.hideNode(this.sectionPriceEditor, true);
                this.hideNode(this.sectionTextEditor, false);

                this.edit_evServiceTxt.setValue(entity.description, true);
                break;
            default:
        }
    }

    private _onDlgResult(result: number) {

        if (result === 1) {
            this._saveChanges();
        }
    }

    private _saveChanges(): void {
        
        let requestUrl = window.appRoot + "EvBookingEditor/SaveServiceChangesData";

        if (this.changedData != null) {

            this.RequestManager.post(
                requestUrl,
                {
                    jsonData: JSON.stringify(this.changedData)
                },
                lang.hitch(this, this._onSaveEvServiceChangesDataResponse),
                lang.hitch(this, this._onSaveEvServiceChangesDataError),
                false // sync
            );
        }
    }

    private _onSaveEvServiceChangesDataResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast({
            title: this.translations["General_SavingSuccessful"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        if (this.dlg) this.dlg.close(); // silent schließen

        this.destroy();
    }

    private _onSaveEvServiceChangesDataError(err): void {
        this.StandbyStop();

        alert(this.id + " SaveEvServiceChanges: " + err.Message);
        //this.destroy();
    }


    private _onPriceCheckboxInputs(): void {

        let bOversteeredPrice = this.cbOverridePrice.getValue();
        if (bOversteeredPrice === false) {

            this.cbFreePrice.setValue(false, true);
            this.cbTotalPricelist.setValue(false, true);
        }

        let bFreePrice = this.cbFreePrice.getValue();
        if (bFreePrice === false) {

            this.cbTotalPricelist.setValue(false, true);
        }

        let bPriceTotalPricelist = this.cbTotalPricelist.getValue();

        this.setAttributeValue("is_oversteered_price", this.cbOverridePrice.getValue());
        this.setAttributeValue("is_free_price", this.cbFreePrice.getValue(), true);
        this.setAttributeValue("is_price_total_pricelist", this.cbTotalPricelist.getValue());

        this.adjustPricelistEdit(bOversteeredPrice, bFreePrice, bPriceTotalPricelist);

        //this.checkDirty();
    }

    private adjustPricelistEdit(bOversteeredPrice: boolean, bFreePrice: boolean, bPriceTotalPricelist: boolean): void {

        this.inputPriceUnitChange.setReadonly(true);
        this.inputPriceUnitPriceList.setReadonly(true);
        this.inputPriceTotalPriceList.setReadonly(true);
        this.inputDiscount.setReadonly(true);

        if (bOversteeredPrice) {

            this.inputPriceUnitChange.setReadonly(false);
            this.inputDiscount.setReadonly(false);
        }
        if (bFreePrice) {

            this.inputPriceUnitChange.setReadonly(true);
            this.inputPriceUnitPriceList.setReadonly(false);
        }
        if (bPriceTotalPricelist) {

            this.inputPriceTotalPriceList.setReadonly(false);
            this.inputPriceUnitPriceList.setReadonly(true);
        }
    }

    private _onChangepriceDataNumberInputs(): void {

        let price_unit_change = this.inputPriceUnitChange.getValue();
        price_unit_change === null ? this.setAttributeValue("price_unit_change", 0, true) : this.setAttributeValue("price_unit_change", price_unit_change, true);

        let price_unit_pricelist = this.inputPriceUnitPriceList.getValue();
        price_unit_pricelist === null ? this.setAttributeValue("price_unit_pricelist", 0) : this.setAttributeValue("price_unit_pricelist", price_unit_pricelist);

        let price_total_pricelist = this.inputPriceTotalPriceList.getValue();
        price_total_pricelist === null ? this.setAttributeValue("price_total_pricelist", 0) : this.setAttributeValue("price_total_pricelist", price_total_pricelist);

        let discount = this.inputDiscount.getValue();
        discount === null ? this.setAttributeValue("discount", 0) : this.setAttributeValue("discount", discount);
        this.checkDirty();
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvServiceBookingEditor);